<template>
	<search-list :pageSizes="[50,75,100]" apiPath="/report/list" :where="where" :order="order" :searchKeys="searchKeys" :handleResponse="handleResponse" :attributes="group_model" ref="sl" notSearchAll>
		<div class="mm-select">
			<div class="column-select">
				<mm-lc title="Time Zone" class="gim-select">
					<mm-time-zone v-model="where.time_zone" :clearable="false"/>
				</mm-lc>
				<!-- <mm-lc title="UTC+8">
					<el-switch v-model="utc_8"></el-switch>
				</mm-lc> -->
				<mm-lc title="Time">
					<mm-date-range v-model="where.time" :initTime="init_time"/>
				</mm-lc>
				<mm-lc title="Report Model" class="gim-select">
					<mm-report-select-model v-model="where.report_model" :clearable="false"/>
				</mm-lc>
				<mm-lc title="Group Model" class="gim-select">
					<mm-report-group-model v-model="group_model" return-array multiple/>
				</mm-lc>
				<mm-lc title="Advertiser" class="gim-select">
					<mm-adv-select v-model="where.adv_id" multiple/>
				</mm-lc>
				<mm-lc title="Channel" class="gim-select">
					<mm-channel-select v-model="where.networkid" multiple/>
				</mm-lc>
				<mm-lc title="Channel type" class="gim-select">
					<mm-channel-type v-model="where.channel_type" :multiple="!where.gaid_idfa_ratio"/>
				</mm-lc>
				<mm-lc title="Region" class="gim-select">
					<mm-offer-geos v-model="where.country" :multiple="!where.gaid_idfa_ratio"/>
				</mm-lc>
				<mm-lc title="Platform" class="gim-select">
					<mm-offer-platform v-model="where.os" :multiple="!where.gaid_idfa_ratio"/>
				</mm-lc>
				<mm-lc title="Offer Manager" class="gim-select">
					<mm-users v-model="where.offer_bd"></mm-users>
				</mm-lc>
			</div>
		</div>

		<div class="switch-select" slot="switchActions">
			<!-- <mm-lc title="Not Clicks">
				<el-switch v-model="where.not_click"></el-switch>
			</mm-lc>
			<mm-lc title="Offer Status">
				<el-switch v-model="where.offer_status"></el-switch>
			</mm-lc>
			<mm-lc title="GAID_IDFA Ratio">
				<el-switch v-model="where.gaid_idfa_ratio"></el-switch>
			</mm-lc> -->
			<div class="switch-actions" v-show="!is_show_auth">
				<el-radio-group size="mini" v-model="where.auth_type">
					<el-radio-button label="adv"></el-radio-button>
					<el-radio-button label="normal"></el-radio-button>
					<el-radio-button label="channel"></el-radio-button>
				</el-radio-group>
			</div>
			<div class="switch-actions" v-show="is_show_auth">
				<span>auth:&nbsp;&nbsp;</span>
				<mm-users v-model="where.auth_manager" multiple :showMoreOptions="false" not_admin size="mini"></mm-users>
			</div>
			<div class="switch-actions">
				<el-tooltip class="item" effect="dark" content="Not Click" placement="bottom">
					<el-button type="text">Not Click:</el-button>
				</el-tooltip>
				<el-switch v-model="where.not_click"></el-switch>
			</div>
			<div class="switch-actions">
				<el-tooltip class="item" effect="dark" content="Offer Status" placement="bottom">
					<el-button type="text">Offer Status:</el-button>
				</el-tooltip>
				<el-switch v-model="where.offer_status"></el-switch>
			</div>
			<div class="switch-actions">
				<el-tooltip class="item" effect="dark" content="gaid idfa Ratio" placement="bottom">
					<el-button type="text">gaid-idfa:</el-button>
				</el-tooltip>
				<el-switch v-model="where.gaid_idfa_ratio"></el-switch>
			</div>
			<div class="switch-actions">
				<el-tooltip class="item" effect="dark" content="Click Cost" placement="bottom">
					<el-button type="text">Click Cost:</el-button>
				</el-tooltip>
				<el-switch v-model="show_click_cost" @change="isShowClickCostDialog"></el-switch>
			</div>
			<div class="switch-actions">
				<el-tooltip class="item" effect="dark" placement="bottom">
					<div slot="content">
						Manual Conver<br/>
						<span style="color:#f56c6c;">* Only able when adv_id, networkid, offerid exist and time is within 24 hours</span>
					</div>
					<el-button type="text">Manual Conver:</el-button>
				</el-tooltip>
				<el-switch v-model="show_manual_conver" :disabled="manual_conver_btn_disable"></el-switch>
			</div>
			<!-- <div class="switch-actions">
				<el-popover trigger="hover">
					<div>
						<div class="switch-action">
							<span>Not Click:</span>
							<el-switch v-model="where.not_click"></el-switch>
						</div>
						<div class="switch-action">
							<span>Offer Status:</span>
							<el-switch v-model="where.offer_status"></el-switch>
						</div>
						<div class="switch-action">
							<span>gaid idfa Ratio:</span>
							<el-switch v-model="where.gaid_idfa_ratio"></el-switch>
						</div>
					</div>
				<el-button size="mini" slot="reference" class="switch-popover-button" >Switch Buttons</el-button>
				</el-popover>
			</div> -->
		</div>
		
		<div slot="actions" >
		<el-popover trigger="hover" placement="top">
			<div>
				<el-button @click="log(true)">All</el-button>
				<el-button @click="log(false)">To Channel</el-button>
			</div>
		<el-button class="log-button"  slot="reference"><i class="el-icon-s-finance" /></el-button>
		</el-popover>
		</div>
		<div slot="actions" />
			<mm-table slot="dataTable" slot-scope="res" :res="res"  @sort-change="sortChange" ref="reporttable">
			<template slot-scope="etc">
			<el-table-column label="Time" prop="time" key="time" v-if="column_show.time" sortable="custom" fixed="left" />
			<el-table-column label="Date" prop="date" key="date" v-if="column_show.date" sortable="custom" fixed="left" />
			<el-table-column label="Adv. Id" prop="adv_id" key="adv_id" v-if="column_show.adv_id" fixed="left" width="90"/>
			<el-table-column label="Adv. name" prop="adv" key="adv" v-if="column_show.adv_id" fixed="left" width="100" >
				<mm-get-detail slot-scope="sp" :row_name="sp.row.adv" :row_id="sp.row.adv_id" row_type='adv' />
			</el-table-column>
			<el-table-column label="Channel Id" prop="networkid" key="networkid" v-if="column_show.networkid" fixed="left" width="100"/>
			<el-table-column label="Channel Name" prop="network" key="network" v-if="column_show.networkid" fixed="left" width="121">
				<mm-get-detail slot-scope="sp" :row_name="sp.row.network" :row_id="sp.row.networkid" row_type='channel' />
			</el-table-column>
			<el-table-column label="SubChannel" prop="sub_channel" key="sub_channel" v-if="column_show.sub_channel" fixed="left" width="105"/>
			<el-table-column label="App Name" prop="aff_sub5" key="aff_sub5" v-if="column_show.aff_sub5" fixed="left" width="105"/>
			<el-table-column label="App Id" prop="aff_sub3" key="aff_sub3" v-if="column_show.aff_sub3" fixed="left" width="105"/>
			<el-table-column label="Channel Type" prop="channel_type" key="channel_type" v-if="column_show.channel_type" fixed="left" width="120"/>
			<el-table-column label="Package Name" prop="package_id" key="package_id" v-if="column_show.package_id" fixed="left" width="125"/>
			<el-table-column label="Offer Id" :renderHeader="etc.renderHeaderCopy" prop="offerid" key="offerid" width="125" v-if="column_show.offerid" fixed="left"/>
			<el-table-column label="Offer Name" prop="offer_name" key="offer_name" v-if="column_show.offerid" fixed="left" width="180">
				<mm-get-detail slot-scope="sp" row_type="offer" :row_id="sp.row.offerid" :row_name="sp.row.offer_name" />
			</el-table-column>
			<el-table-column label="Adv. Offer Id" prop="adv_offer_id" key="adv_offer_id" v-if="column_show.adv_offer_id" fixed="left" width="110"/>
			<el-table-column label="Offer Status" prop="offer_status"  key="offer_status" v-if="column_show.offer_status" fixed="left">
				<span slot-scope="sp" :class="'status-'+sp.row.offer_status">{{sp.row.offer_status.toUpperCase()}}</span>
			</el-table-column>
			<el-table-column label="Event Name" prop="event_name" key="event_name" v-if="column_show.event_name" fixed="left" width="150"/>
			<el-table-column label="Event Value" prop="event_value" key="event_value" v-if="column_show.event_value" fixed="left" width="150"/>
			<el-table-column label="Manual Status" prop="offer_manual_status"  key="offer_manual_status" v-if="column_show.offer_status" fixed="left">
				<span slot-scope="sp" :class="'status-'+sp.row.offer_manual_status">{{sp.row.offer_manual_status.toUpperCase()}}</span>
			</el-table-column>
			<el-table-column label="Click Cap" prop="daily_click"  key="daily_click" v-if="column_show.offer_status" fixed="left"/>
			<el-table-column label="Offer Cap" prop="offer_cap"  key="offer_cap" v-if="column_show.offer_status" fixed="left"/>
			<el-table-column label="Region" prop="country" key="country" v-if="column_show.country" fixed="left"/>
			<el-table-column label="Platform" prop="os" key="os" v-if="column_show.os" fixed="left"/>
			<el-table-column label="Cheat Reason" prop="type" key="type" v-if="column_show.type" fixed="left"/>
			<el-table-column label="Server Click" prop="traffic_type" width="68" key="traffic_type" v-if="column_show.traffic_type" fixed="left"/>

			<mm-summary-column label="Clicks" prop="click" key="click" sortable="custom" v-if="show_click" width="90"/>
			<mm-summary-column label="Conv." prop="conv" key="conv" sortable="custom" width="90" :is_slot="true">
				<div slot-scope="is">
					<div style="display:flex;align-items:center;">
						<span>{{is.sp.row.conv}}</span>
						<el-button v-if="show_manual_conver" @click="openManualConverDialog(is.sp.row)" type="text" style="margin-left:5px;"><i class="el-icon-circle-plus-outline"/></el-button>
					</div>
				</div>
			</mm-summary-column>
			<mm-summary-column label="Deduct Conv." prop="ded_conv" key="ded_conv" sortable="custom" width="90" />
			<mm-summary-column label="Sent  Conv." prop="sent_conv" key="sent_conv" sortable="custom" width="110" />
			<mm-summary-column label="CVR" prop="cvr" key="cvr" v-if="show_click"/>
			<mm-summary-column label="Sent CVR" prop="sent_cvr" key="sent_cvr" v-if="show_click"/>
			<mm-summary-column label="Avg. Price" prop="avg_price" key="avg_price" />
			<mm-summary-column label="Avg. Payout" prop="avg_payout" key="avg_payout" />
			<mm-summary-column label="gaid_idfa Rate" v-if="show_GI" width="90" prop="GI_ratio" key="GI_ratio" />
			<mm-summary-column label="Revenue" prop="rev" key="rev" sortable="custom" width="110" fixed="right"/>
			<mm-summary-column label="Cost($)" prop="cost" key="cost" sortable="custom" fixed="right" width="110"/>
			<mm-summary-column v-if="click_cost_form.show_column" label="Click Cost($)" prop="click_cost" key="click_cost" fixed="right" width="110"/>
			<mm-summary-column label="Profit" prop="profit" key="profit" fixed="right" width="110"/>
			<mm-summary-column label="ROI" prop="roi" key="roi" />
			<mm-summary-column label="Deduct Rate($)" prop="ded_rate" key="ded_rate" />
			<mm-summary-column label="ECPC" prop="ecpc" key="ecpc" v-if="show_click" />
			</template>
		</mm-table>

		<el-dialog :visible.sync="click_cost_dialog" width="500px" append-to-body @close="clickCostDialogClose">
			<span slot="title">Click Cost</span>
			<el-form label-width="150px" :model="click_cost_form">
				<el-form-item label="Million Click / Cost" prop="million_click_cost" style="max-width:100%;">
					<el-input v-model="click_cost_form.million_click_cost" type="number" />
				</el-form-item>
				<el-form-item label="Change Profit" prop="change_profit" style="max-width:100%;">
					<el-switch v-model="click_cost_form.change_profit"></el-switch>
				</el-form-item>
				<el-form-item class="form-item" style="max-width:100%;text-align:right;">
					<el-button type="primary" @click="saveMillionCLickCost">Submit</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

		<el-dialog :visible.sync="manual_conver_dialog" width="500px" append-to-body @close="manualConverDialogClose">
			<span slot="title">Manual Conver</span>
			<el-form label-width="150px" :model="manual_conver_form" :show-message="false">
				<el-form-item label="Count" prop="count" style="max-width:100%;">
					<el-input v-model="manual_conver_form.count" type="number" :step="1" :min="1" :max="10" />
				</el-form-item>
				<el-form-item label="Event Value" prop="event_value" style="max-width:100%;">
					<el-input v-model="manual_conver_form.event_value" />
				</el-form-item>
				<el-form-item class="form-item" style="max-width:100%;text-align:right;">
					<el-button type="primary" @click="saveManualConver" :disabled="manual_conver_loading">Submit</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</search-list>
</template>

<script>
export default {
	data() {
		const searchKeys = {
			offerid: { label: "Offer ID" },
			adv_offer_id: { label: "Adv. Offer ID" },
			sub_channel: { label: "SubChannel" },
			fuzzy_sub_channel: { label: "Fuzzy SubChannel",fuzzy: true,key:"sub_channel" },
			package_id: { label: "Package ID" }
		};
		const user_info = this.$utils.getCookies(['group_name']);
		const is_show_auth = (user_info.group_name === 'admin');
		return {
			searchKeys,
			where: {
				time_zone: 8,
				time: {},
				report_model: "global",
				adv_id:'',
				networkid:'',
				channel_type:'',
				country:'',
				os:'',
				not_click:false,
				traffic_type: '',
				gaid_idfa_ratio:false,
				status:false,
				auth_type: is_show_auth ? '' : 'adv',
			},
			is_show_auth,
			order:[['rev','desc']],
			group_model: ['adv_id'],
			utc_8:false,
			gaid_idfa_ratio:false,
			traffic_type: false,
			column_show:{
				adv_id:true,
				networkid:false,
				sub_channel:false,
				channel_type:false,
				package_id:false,
				offerid:false,
				adv_offer_id:false,
				country:false,
				os:false,
				date:false,
				time:false,
				type:false,
				traffic_type:false,
				offer_status:false,
				aff_sub5:false,
				aff_sub3:false,
				event_name: false,
				event_value: false,
			},
			show_click:true,
			show_GI: false,
			show_click_cost: false,
			show_manual_conver: false,
			manual_conver_btn_disable: true,
			init_time: [],
			click_cost_dialog: false,
			click_cost_form: {
				million_click_cost: 0.2083333333,
				change_profit: false,
				show_column: false,
			},
			manual_conver_dialog: false,
			manual_conver_loading: false,
			manual_conver_form: {
				event_value: '',
				count: 1,
				adv_id: '',
				channel_id: '',
				offerid: '',
			}
		};
	},
	watch: {
		utc_8(type) {
			if(type == true) {
				this.where.time_zone = 8;
			} else {
				this.where.time_zone = 0;
			}
		},
		'where.gaid_idfa_ratio'(type) {
			if (type == true) {
				this.where.gaid_idfa_ratio = true;
				this.where.adv_id = '';
				this.where.networkid = '';
				this.where.channel_type = '';
				this.where.country = '';
				this.where.os = '';
			} else {
				this.where.gaid_idfa_ratio = false;
				this.where.adv_id = {$in:[]};
				this.where.networkid = {$in:[]};
				this.where.channel_type = {$in:[]};
				this.where.country = {$in:[]};
				this.where.os = {$in:[]};
			}
		},
		'where.report_model'(model) {
			if (model === 'global') {
				this.order[0] = ['rev','desc'];
			} else {
				this.order[0] = ['time', 'asc'];
			}
		},
		'where.auth_type'(type) {
			if (type === 'adv') {
				this.group_model = ['adv_id'];
			} else if (type === 'channel') {
				this.group_model = ['networkid'];
			}
		},
		traffic_type(v) {
			if (v === true) {
				this.where.traffic_type = '1';
			} else {
				this.where.traffic_type = '';
			}
		}
	},
	methods: {
		handleResponse(body){
			for(const show in this.column_show){
				const row = body.rows[0] || {};
				if(row[show] != null){
					this.column_show[show] = true;
					if(this.where.group_model && this.where.group_model.$in.indexOf(show) == -1){
						this.where.group_model.$in.push(show);
					}
				}else{
					this.column_show[show] = false;
				}
			}
			// is show manual conver button
			const row = body.rows[0] || {};
			const gteTime = this.where.time.$gte;
			const minTime = (new Date().getTime() - 24 * 60 * 60 * 1000) / 1000;
			if (row.adv_id && row.networkid && row.offerid && gteTime > minTime) {
				this.manual_conver_btn_disable = false;
			} else {
				this.manual_conver_btn_disable = true;
				this.show_manual_conver = false;
			}

			this.show_click = this.where.not_click === false ? true : false;
			this.show_GI = this.where.gaid_idfa_ratio === false ? false : true;
			const params = {
				where: JSON.stringify(this.where),
				group_model: JSON.stringify(this.group_model),
				order: JSON.stringify(this.order),
			}
			this.$router.push({
				query:params,
			})
			if (this.show_click_cost) {
				body.rows.forEach(row => {
					row.click_cost = Number(((row.click * this.click_cost_form.million_click_cost) / 1000000).toFixed(2));
					if (this.click_cost_form.change_profit) {
						row.profit = Number((row.profit - row.click_cost).toFixed(2));
					}
				});
				body.summary.click_cost = Number(((body.summary.click * this.click_cost_form.million_click_cost) / 1000000).toFixed(2));
				if (this.click_cost_form.change_profit) {
					body.summary.profit = Number((body.summary.profit - body.summary.click_cost).toFixed(2));
				}
			}

		},
		async sortChange(column){
			if(column.order == 'ascending'){
				this.order[0] = [column.prop,'asc']
			}else if(column.order == 'descending'){
				this.order[0] = [column.prop,'desc']
			}else {
				this.order[0] = ['rev','desc']
			}
			await this.$refs.sl.refresh();
		},
		async log(has_ded){
			if (!has_ded) {
				this.where.is_def = 0;
			}
			const model = this.where.report_model;
			this.where.report_model = 'log';
			try{
				const result = await this.$refs.sl.getCsv();
			}catch(result){
				// console.log(result);
			}
			this.where.report_model = model;
			delete this.where.is_def;
		},
		isShowClickCostDialog() {
			if (this.show_click_cost) {
				this.click_cost_dialog = true;
			} else {
				this.click_cost_form.show_column = false;
			}
		},
		saveMillionCLickCost() {
			if (!this.click_cost_form.million_click_cost) {
				this.$message.warning('Please input Million Click Cost');
				return;
			}
			this.click_cost_form.show_column = true;
			this.click_cost_dialog = false;
			this.$refs.sl.refresh();
		},
		clickCostDialogClose() {
			this.click_cost_dialog = false;
			if (!this.click_cost_form.million_click_cost) {
				this.show_click_cost = false;
				this.click_cost_form.show_column = false;
			}
		},
		openManualConverDialog(row) {
			this.manual_conver_form.adv_id = row.adv_id;
			this.manual_conver_form.channel_id = row.networkid;
			this.manual_conver_form.offerid = row.offerid;
			this.manual_conver_form.event_value = '';
			this.manual_conver_form.count = 1;
			this.manual_conver_dialog = true;
		},
		manualConverDialogClose() {
			this.manual_conver_dialog = false;
		},
		async saveManualConver() {
			if (!this.manual_conver_form.count || this.manual_conver_form.count <= 0) {
				this.$message.warning('Please input Count');
				return;
			}
			this.manual_conver_loading = true;
			this.$post('/report/manualConver', {where:this.manual_conver_form}).then(() => {
				this.manual_conver_dialog = false;
				this.$message.success('Manual conversion saved successfully,the report will update the data in a few minutes');
			}).finally(() => {
				this.manual_conver_loading = false;
			});
			// this.$refs.sl.refresh();
		}
	},
	created() {
		const params = this.$route.query;
		if (params.where) {
			// if (params.today) {
			// 	const time = this.where.time;
			// 	this.where = JSON.parse(params.where);
			// 	this.where.time = time;
			// } else {
			// 	this.where = JSON.parse(params.where);
			// 	const time = this.where.time;
			// 	const h = new Date(time.$gte * 1000).getHours();
			// 	this.init_time = [ new Date((time.$gte - h * 3600) * 1000), new Date((time.$lt - h * 3600) * 1000) ];
			// }
			// use today
			const time = this.where.time;
			this.where = JSON.parse(params.where);
			this.where.time = time;
		}
		if (params.group_model) {
			this.group_model = JSON.parse(params.group_model);
		}
		if (params.order) {
			this.order = JSON.parse(params.order);
		}
	},

};
</script>

<style scoped>
.mm-select {
	display: flex;
	width: 100%;
	flex-direction: column;
}
.column-select {
	display: flex;
	flex-direction: row;
	width: 100%;
	overflow: hidden;
	overflow-x: scroll;
}
.bt-create {
  position: relative;
  right: 0px;
}
.log-button {
	background-color: #376bf0;
	color: #fff;
}
.log-icon {
	color: white;
}
.switch{
	/* width: 130px;
	height: 32px;
	display: flex;
	justify-content: center;
	align-items: center; */
}

.switch-actions {
	padding-right: 10px;
}
.switch-action {
	display: flex;
	justify-content: space-between;
	padding-bottom: 10px;
}
.switch-popover-button {
	background-color: #5976c0;
	color: #fff;
}
.switch-select {
	display: flex;
	align-items: center;
	padding-left: 20px;
	font-size: 13px;
}
</style>
